import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TokenProcess } from '../@core/constants';
import { SendTokenRequest } from '../models/request/send-token-request';
import { ResponseModel } from '../models/response-model';
import { TokenAuthorization } from '../models/token-authorization';

@Injectable({
  providedIn: 'root'
})
export class TokenAuthorizationService {

  private readonly url = `${environment.url}/authToken`;
  constructor(private readonly http: HttpClient) { }

  generateToken(request: SendTokenRequest) {
    return this.http.post(`${this.url}/send`, request);
  }

  useToken(token: string, process: TokenProcess) {
    let params = new HttpParams().append("process", process);
    return this.http.post<ResponseModel<TokenAuthorization>>(`${this.url}/${token}/use`, undefined, { params });
  }
}
